import Component from '../vendor/Component'

export default class ProductStickyAddToCart extends Component {
    constructor(elem, theme, options, ctx) {
        super(elem, theme, options, ctx)

        this.selectors = {
            PDPProductForm: '#main-product .product-form',
            productInfo: '#product-info',
            productFormButtons: '#product-info .button-container',
            masterSelect: 'select.product-master-selector',
            radioOption: 'radio-option',
            singleOptionSelector: 'single-option-selector',
            optionContainer: '.product-option-wrapper',
            optionHeadingContainer: 'option-heading-wrapper',
            optionHeadingName: 'option-name',
            optionRadios: 'option-radios',
            formattedValue: '.main-product-sticky__option-value',
            price: '.main-product-sticky__price .price',
            mobileButtonPrice: '.main-product-sticky__cta.button-container .price',
            ctaSize: '.main-product-sticky__cta button.add-to-cart .cta-size',
        }


        this.PDPProductForm = document.querySelector(this.selectors.PDPProductForm)

        if (!this.PDPProductForm) return

        this.productInfo = document.querySelector(this.selectors.productInfo)
        this.productOptionsWrapper = document.querySelector(this.selectors.optionContainer)
        this.productFormButtons = document.querySelector(this.selectors.productFormButtons)

        this.externalMasterSelect = this.PDPProductForm.querySelector(this.selectors.masterSelect)
        this.internalMasterSelect = this._elem.querySelector(this.selectors.masterSelect)

        // bottom of main PDP product form
        this.fixedBarThreshold = this.PDPProductForm.offsetTop + this.PDPProductForm.offsetHeight + 100

        this.isTicking = false
        this.lastKnownY = window.scrollY

        this._isFixed = this.lastKnownY > this.fixedBarThreshold

        this.onScroll = this.onScroll.bind(this)
        this.updateEl = this.updateEl.bind(this)
        this.handleVariantChange = this.handleVariantChange.bind(this)
        this.handleResize = this.handleResize.bind(this)

        this.priceEl = this._elem.querySelector(this.selectors.price)
        this.mobileButtonPriceEl = this._elem.querySelector(this.selectors.mobileButtonPrice)

        this.mobileBreakpoint = 768
        this.isMobile = window.innerWidth < this.mobileBreakpoint
    }

    mount () {
        window.addEventListener('scroll', this.onScroll)
        window.addEventListener('resize', this.handleResize)
        this.externalMasterSelect.addEventListener('change', this.handleVariantChange)

        this.requestTick()

        this.syncStickyUiFromMain()
        this.updateCtaSize()
    }

    unmount () {
        window.removeEventListener('scroll', this.onScroll)
        window.removeEventListener('resize', this.handleResize)
        this.externalMasterSelect.removeEventListener('change', this.handleVariantChange)
    }

    handleResize () {
        this.isMobile = window.innerWidth < this.mobileBreakpoint
        this.requestTick()
    }

    onScroll () {
        this.lastKnownY = window.scrollY || window.pageYOffset

        window.BAO.Utils.debounce(() => {
            this.requestTick()
        }, 500)()
    }

    requestTick () {
        if (!this.isTicking) window.requestAnimationFrame(this.updateEl)

        this.isTicking = true
    }

    getHeaderHeight () {
        const html = document.documentElement
        const headerHeight = parseInt(getComputedStyle(html).getPropertyValue('--height-header')) || 0
        const topBarHeight = parseInt(getComputedStyle(html).getPropertyValue('--header-top-bar-height')) || 0

        return headerHeight + topBarHeight
    }

    isElementInViewport () {
        if (!this.productOptionsWrapper || !this.productFormButtons) return false

        const optionsRect = this.productOptionsWrapper.getBoundingClientRect()
        const buttonsRect = this.productFormButtons.getBoundingClientRect()
        const headerHeight = this.getHeaderHeight()

        const optionsInView = optionsRect.top < window.innerHeight && optionsRect.top > headerHeight
        const buttonsInView = buttonsRect.bottom > headerHeight && buttonsRect.bottom < window.innerHeight

        return optionsInView || buttonsInView
    }

    updateEl () {
        this.isTicking = false

        if (this.isMobile) {
            this.isFixed = !this.isElementInViewport()
        } else {
            this.isFixed = this.lastKnownY >= this.fixedBarThreshold
        }
    }

    handleVariantChange () {
        this.internalMasterSelect.value = this.externalMasterSelect.value

        this.internalMasterSelect.dispatchEvent(new Event('change'))

        this.updateOptionHeadings()
        this.updatePrice()
        this.updateCtaSize()

        window.requestAnimationFrame(() => {
            this.syncStickyUiFromMain()
        })
    }

    syncStickyUiFromMain () {
        const mainAddToCart = this.PDPProductForm.querySelector('.add-to-cart')
        const stickyAddToCart = this._elem.querySelector('.main-product-sticky__cta button.add-to-cart')
        const stickyPrice = this._elem.querySelector('.main-product-sticky__price')

        if (!mainAddToCart || !stickyAddToCart) return

        const mainIsDisabled = mainAddToCart.disabled
        const mainIsUnavailable = mainAddToCart.classList.contains('unavailable')


        if (mainIsDisabled || mainIsUnavailable) {
            stickyAddToCart.setAttribute('disabled', 'disabled')

            if (mainIsUnavailable) {
                stickyAddToCart.classList.add('unavailable')
            } else {
                stickyAddToCart.classList.remove('unavailable')
            }

            stickyAddToCart.style.display = 'none'
        } else {
            stickyAddToCart.removeAttribute('disabled')
            stickyAddToCart.classList.remove('unavailable')
            stickyAddToCart.style.display = ''
        }

        if (stickyPrice) {
            if (!mainIsDisabled && !mainIsUnavailable) {
                stickyPrice.style.display = ''
            } else {
                stickyPrice.style.display = 'none'
            }
        }
    }

    updateOptionHeadings () {
        const selected_radios = this.PDPProductForm.querySelectorAll(`${this.selectors.optionContainer} input.${this.selectors.radioOption}:checked`);

        if (selected_radios) {
            selected_radios.forEach(selected_radio => {
                const radio_value = selected_radio.value;
                const radio_formatted_value = selected_radio.getAttribute('data-formatted-value');
                const option_name = selected_radio.getAttribute('name').replace(' ', '-').toLowerCase();
                const option_heading = this._elem.querySelector(`.${option_name}-option ${this.selectors.formattedValue}`);
                if (option_heading) {
                    if (radio_formatted_value) option_heading.innerHTML = radio_formatted_value;
                    else if (radio_value) option_heading.innerHTML = radio_value;
                    else option_heading.innerHTML = '';
                }

            });
        }


        // Update Select Headings
        const selected_selects = this.PDPProductForm.querySelectorAll(`.${this.selectors.singleOptionSelector}`);
        if (selected_selects) {

            selected_selects.forEach(select => {
                const selected_option = select.options[select.selectedIndex];

                const option_value = selected_option.value;
                const option_formatted_value = selected_option.getAttribute('data-formatted-value');
                const option_name = select.dataset.optionName.replace(' ', '-').toLowerCase();
                const option_heading = this._elem.querySelector(`.${option_name}-option ${this.selectors.formattedValue}`);
                if (option_heading) {
                    if (option_formatted_value && option_heading.innerHTML != option_formatted_value) option_heading.innerHTML = option_formatted_value;
                    else if (option_value && option_heading.innerHTML != option_value) option_heading.innerHTML = option_value;
                    else option_heading.innerHTML = '';
                }

            });

        }
    }

    updatePrice () {
        this.mobileButtonPriceEl.innerHTML = this.priceEl.innerHTML
    }

    updateCtaSize () {
        const ctaSizeEl = this._elem.querySelector(this.selectors.ctaSize)

        if (!ctaSizeEl) return

        const selectedSizeRadio = this.PDPProductForm.querySelector(`.${this.selectors.optionRadios} input.${this.selectors.radioOption}[name="Size"]:checked`)
        const ctaValue = selectedSizeRadio?.getAttribute('data-cta-value')

        ctaSizeEl.innerHTML = ctaValue ? `${ctaValue} -` : ''
    }

    get isFixed () {
        return this._isFixed
    }

    set isFixed (value) {
        this._isFixed = value

        this._elem.setAttribute('aria-hidden', !value)
    }
}
